// import React, { createContext, useContext, useState } from "react";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [username, setUsername] = useState(localStorage.getItem("username") || "");
//   const [userId, setUserId] = useState(null);

//   // useEffect(() => {
//   //   const storedAuth = localStorage.getItem("isAuthenticated") === "true";
//   //   const storedUserId = localStorage.getItem("userId");

//   //   if (storedAuth && storedUserId) {
//   //     setIsAuthenticated(true);
//   //     setUserId(parseInt(storedUserId)); // Convert to integer
//   //   }
//   // }, []);

//   const login = (providedUsername = "") => {
//     setIsAuthenticated(true);
//     setUsername(providedUsername);
//     setUserId(id);
//     localStorage.setItem("isAuthenticated", "true");
//     localStorage.setItem("username", providedUsername);
//     localStorage.setItem("userId", id);
//   };

//   const logout = () => {
//     setIsAuthenticated(false);
//     setUsername("");
//     localStorage.removeItem("isAuthenticated");
//     localStorage.removeItem("username");
//     localStorage.removeItem("userId");
//   };

//   // 5) Expose username and setUsername along with existing values
//   return (
//     <AuthContext.Provider
//       value={{
//         isAuthenticated,
//         login,
//         logout,
//         username,
//         setUsername,   
//         userId
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userId, setUserId] = useState(null);
  const [username, setUsername] = useState(localStorage.getItem("username") || "");
  const [profilePicture, setProfilePicture] = useState(localStorage.getItem("profilePicture") || "");
  const API_BASE_URL = process.env.REACT_APP_API_SOURCE;

  // Load authentication status from localStorage on mount
  // Load authentication status from localStorage on mount
  // useEffect causes the whole caching issue but its useful in that when refresh, you dont get logged out
  // This ensures persistent login sessions by restoring the previous state from localStorage when the app reloads
  // Without useEffect, if you refresh you would get logged out
  useEffect(() => {
    const storedAuth = localStorage.getItem("isAuthenticated") === "true";
    const storedUserId = localStorage.getItem("userId");

    if (storedAuth && storedUserId && !isNaN(storedUserId)) {
      setIsAuthenticated(true);
      setUserId(parseInt(storedUserId)); // Convert to integer
      fetchUsername(parseInt(storedUserId));
    } else {
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("userId");
    }
  }, []);

  const login = async (id) => {
    const userId = parseInt(id, 10); // ✅ Ensure userId is an integer
    if (!isNaN(userId)) {
    setIsAuthenticated(true);
    setUserId(userId);
    localStorage.setItem("isAuthenticated", "true");
    localStorage.setItem("userId", userId);

    fetchUsername(userId);
    } else {
      console.error("Invalid userId received:", id);
    }
  };
  
  const logout = () => {
    setIsAuthenticated(false);
    setUserId(null);
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userId");
    localStorage.removeItem("username");
  };

  const deleteAccount = () => {
    setIsAuthenticated(false);
    setUserId(null);
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userId");
  };

   // ✅ Fetch username from getUsername.php
   const fetchUsername = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/backend/api/getUsername.php?userId=${id}`);
      const result = await response.json();
      
      if (result.status === "success") {
        setUsername(result.username);
        localStorage.setItem("username", result.username);
      } else {
        console.error("Failed to fetch username:", result.message);
      }
    } catch (error) {
      console.error("Error fetching username:", error);
    }
  };

  // ✅ Function to update username after change
  const updateUsername = (newUsername) => {
    setUsername(newUsername);
    localStorage.setItem("username", newUsername);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, userId, login, logout, deleteAccount, username, setUsername: updateUsername, profilePicture, setProfilePicture }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);